query GetAccountEnrichment($accountId: ID!) {
    accountEnrichment(accountId: $accountId) {
        label
        displayLabel
        value
        isNew
    }
}
